import { Link } from 'gatsby';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { IconLink } from './IconLink';
import { StyledLinkList } from './LinkList';
import { Typography } from './Typography';
import { Kfh_ContentPageUmbracoType } from '../types/graphqlTypes';

export interface HubNavigationProps {
  currentPageId: string;
  resourceHub: Kfh_ContentPageUmbracoType;
  templateName: string;
}

const StyledHubNavigation = styled.div`
  ${({ theme: { colors, space } }) => css`
    margin-top: ${space.lg};
    nav {
      margin-top: ${space.lg};
    }
    a {
      text-decoration: none;

      &:hover {
        text-decoration: underline;
        color: ${colors.brand.default};
      }

      &.is-active {
        color: ${colors.brand.default};
      }
    }
  `};
`;

const StyledLink = styled(Link)`
  ${({ theme: { space } }) => css`
    padding: ${space.md} 0;
    display: block;
  `};
`;

const StyledListItem = styled.li`
  ${({ theme: { borders } }) => css`
    border-top: ${borders.default};

    &:last-child {
      border-bottom: ${borders.default};
    }
  `};
`;

const StyledChildList = styled(StyledLinkList)`
  ${({ theme: { space } }) => css`
    margin-bottom: ${space.md};
  `};
`;

// URL of the page to hide
const HIDDEN_PAGE_URL = '/buyers/stamp-duty-calculator-test/';

export const HubNavigation: FC<HubNavigationProps> = ({
  currentPageId,
  resourceHub: { relativeUrl, pageName, remoteChildren },
  templateName,
  ...rest
}) => {
  console.log('remoteChildren', remoteChildren);
  return (
    <StyledHubNavigation {...rest}>
      <Typography component="h3" variant="titleMedium">
        <Link to={relativeUrl}>{pageName}</Link>
      </Typography>
      <nav>
        <ul>
          {remoteChildren
            // Apply filter for template name AND hidden URL at first level
            .filter((page) => page.layout?.remoteTypeName === templateName && page.relativeUrl !== HIDDEN_PAGE_URL)
            .map(
              ({ pageName: childName, relativeUrl: childRelativeUrl, remoteChildren: childRemoteChildren }, index) => {
                // Only show children if the current page ID is within the children AND the layout
                const showChildren =
                  childRemoteChildren &&
                  childRemoteChildren.length > 0 &&
                  childRemoteChildren.filter((e) => e.id === currentPageId && e.layout?.remoteTypeName === templateName)
                    .length > 0;

                return (
                  <StyledListItem key={`hub-nav-${index}`}>
                    <StyledLink to={childRelativeUrl} activeClassName="is-active" partiallyActive>
                      <Typography component="span" variant="titleSmall">
                        {childName}
                      </Typography>
                    </StyledLink>

                    {showChildren && (
                      <StyledChildList>
                        {childRemoteChildren
                          // Filter out the specific page with the URL we want to hide
                          .filter(({ relativeUrl: url }) => url !== HIDDEN_PAGE_URL)
                          .map(({ pageName: childChildName, relativeUrl: childChildRelativeUrl }, childIndex) => (
                            <li key={`hub-nav-level-2-${childIndex}`}>
                              <IconLink arrowLeft url={childChildRelativeUrl} label={childChildName} topAlignIcon />
                            </li>
                          ))}
                      </StyledChildList>
                    )}
                  </StyledListItem>
                );
              }
            )}
        </ul>
      </nav>
    </StyledHubNavigation>
  );
};
